var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "trial__header" },
        [
          _c("p", { staticClass: "fs-6 mb-0 trial__title" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t.__(
                    "common.labels.15_days_free_trial_without_obligation"
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("underline-straight", {
            staticClass: "block trial__underline mx-auto"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "trial__baseline" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$t.__("common.labels.freely_test_all_features")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "mx-auto my-3 trial__img",
        attrs: {
          src: _vm.banner,
          alt: _vm.$t.__("common.labels.freely_test_all_features_alt")
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "fs-4 mb-3 trial__subtitle mt-0" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$t.__("common.labels.many_company_use_sellsy_every_day")
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("customer-logo")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }